/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GcpServiceOperationEnum = 'ENABLE' | 'DISABLE';

export const GcpServiceOperationEnum = {

    ENABLE: 'ENABLE' as GcpServiceOperationEnum,

    DISABLE: 'DISABLE' as GcpServiceOperationEnum
};

